export const API_BASE_URL = "https://backend.rtm.jo";
// export const API_BASE_URL = "http://localhost:3000";

export const buildApiUrl = (path = "") => {
  if (!path) {
    return API_BASE_URL;
  }

  if (/^(https?:\/\/|data:)/i.test(path)) {
    return path;
  }

  return `${API_BASE_URL}/${String(path).replace(/^\/+/, "")}`;
};
